import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/enviroments/environment';
import { ApiResponse } from './api-response.interface';

export interface Company {
  IdCompany: number;
  Name: string;
  BusinessName: string;
}

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) { }

  getCompanies(page: number = 1, limit: number = 100): Observable<ApiResponse> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    return this.http.get<ApiResponse>(this.apiUrl, { params });
  }

  getCompanyById(id: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`${this.apiUrl}/${id}`);
  }

  setSelectedCompany(company: Company): void {
    const companyJson = JSON.stringify(company);
    localStorage.setItem('selectedCompany', companyJson);
  }

  getSelectedCompany(): Company | null {
    const companyJson = localStorage.getItem('selectedCompany');
    if (companyJson) {
      try {
        return JSON.parse(companyJson);
      } catch (e) {
        console.error('Error parsing selectedCompany:', e);
        return null;
      }
    }
    return null;
  }

  clearSelectedCompany(): void {
    localStorage.removeItem('selectedCompany');
  }
}
